import React from 'react';

import './access.scss';

const Access = () => {
    return (
        <section className="access" id="access" data-aos="flip-down">
            <div className="container">
                <div className="row">
                    <div className="col-6">
                        <h3 className="g-h2">
                            Jak uzyskać dostęp do&nbsp;aplikacji?
                        </h3>
                        <p className="g-desc">
                            Zanim zainstalujesz aplikację, zgłoś się do swojego ośrodka mukowiscydozy w celu uzyskania QR kodu niezbędnego do zalogowania się do aplikacji. Kliknij w przycisk i zobacz aktualną listę ośrodków leczenia mukowiscydozy.
                        </p>
                        <a href="https://pcfs.pl/osrodki-leczenia-mukowiscydozy-w-polsce/" rel="noreferrer" target="_blank" className="g-btn">Zobacz ośrodki</a>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Access;